import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 14.25V4.5A1.5 1.5 0 0 0 19.5 3h-15A1.5 1.5 0 0 0 3 4.5v9.75Zm2.121 4.641A1.5 1.5 0 0 1 21.75 21H2.25a1.5 1.5 0 0 1-1.371-2.109L3 14.25h18ZM10.5 18h3"
    }, null, -1)
  ]));
}
const computerDeviceLaptop = { render };
export {
  computerDeviceLaptop as default,
  render
};
//# sourceMappingURL=computer-device-laptop.svg.js.map
